import {
  Alert,
  Badge,
  Button,
  ButtonProps,
  Group,
  Loader,
  MantineProvider,
  Modal,
  Paper,
  Select,
  Stack,
  TextInput,
  Textarea,
  createPolymorphicComponent,
  createTheme,
} from '@mantine/core';
import {forwardRef, ReactNode} from 'react';

const theme = createTheme({
  primaryColor: 'ink',
  primaryShade: {light: 8, dark: 4},
  colors: {
    ink: [
      '#f3f5f5',
      '#e3e8e7',
      '#c3ccca',
      '#9eaeab',
      '#7d9490',
      '#667f7b',
      '#526a66',
      '#405653',
      '#263d3a',
      '#102a27',
    ],
  },
  fontFamily: 'Manrope, ui-sans-serif, system-ui, sans-serif',
  headings: {fontFamily: 'Fraunces, Georgia, serif', fontWeight: '650'},
  defaultRadius: 'md',
  focusRing: 'auto',
});

export const PursuitDeckDesignProvider = ({children}: {children: ReactNode}) => (
  <MantineProvider theme={theme} defaultColorScheme="auto">
    {children}
  </MantineProvider>
);

const PrimaryButtonBase = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <Button ref={ref} className="pd-button pd-button--primary" {...props} />
));

const SecondaryButtonBase = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <Button ref={ref} className="pd-button pd-button--secondary" variant="default" {...props} />
));

const QuietButtonBase = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <Button ref={ref} className="pd-button pd-button--quiet" variant="subtle" {...props} />
));

export const PrimaryButton = createPolymorphicComponent<'button', ButtonProps>(PrimaryButtonBase);
export const SecondaryButton = createPolymorphicComponent<'button', ButtonProps>(SecondaryButtonBase);
export const QuietButton = createPolymorphicComponent<'button', ButtonProps>(QuietButtonBase);

export const Surface = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<React.ComponentPropsWithoutRef<'div'>>
>(({children, className = '', ...props}, ref) => (
  <Paper ref={ref} className={'pd-surface ' + className} {...props}>
    {children}
  </Paper>
));
Surface.displayName = 'Surface';

export {
  Alert,
  Badge,
  Group,
  Loader,
  Modal,
  Select,
  Stack,
  TextInput,
  Textarea,
};
